














import { Component, Mixins } from "vue-property-decorator";

// Mixins
import SupportTicketInjectorMixin from "@/mixins/supportTicketInjectorMixin";

// Enums/Data
import { TicketStatusMap, TicketStatusCodes } from "@/data/enums/tickets";

@Component
export default class ClientTicketStatus extends Mixins(
  SupportTicketInjectorMixin
) {
  // Data

  public ticketStatusCodes = TicketStatusCodes;

  // Computed

  public get statusCode() {
    return this.ticketData.ticket.status.code;
  }

  public get dynamicClass() {
    return TicketStatusMap()[this.statusCode]["type"];
  }

  public get ticketDate() {
    return this.$_.get(
      this.ticketData.ticket,
      this.statusCode === TicketStatusCodes.CLOSED ? "closed_at" : "updated_at"
    );
  }
}
